export const DEFAULT_ORG_LOGO = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/generic_company_logo.webp";

export const LOGO_VARIANT_LIGHT = "light";
export const LOGO_VARIANT_DARK = "dark";
export const LOGO_VARIANTS = [
  LOGO_VARIANT_LIGHT,
  LOGO_VARIANT_DARK,
];
export const DEFAULT_SPLASH_IMAGE = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/publication-blog.jpg";
export const FANWEB_EMPTY_STATE_IMAGE = "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/fanweb-empty-state.webp";
export const PUBLICATION_COMMENTS_DEFAULT_CONFIG = {
  enabled: false,
  allowsReply: false,
  allowsLikes: false,
  allowsComments: false,
  allowsUpvoteAndDownvote: false,
  allowsShare: false,
  allowsEditing: false,
  nestedRepliesLimit: 1,
  collapsedReplies: false,
  showReplyReference: false,
  defaultSortingOrder: "Upvotes Descending",
};

export const VALID_UGC_TYPES = {
  none: { name: "None", value: "none" },
  article: { name: "Article", value: "article" },
  multimedia: { name: "Multimedia", value: "multimedia" },
  quickPost: { name: "Quick Post", value: "quickPost" },
};

export const VALID_COMMUNITY_TYPES = {
  none: {
    name: "None",
    value: "none",
  },
  chat: {
    name: "Chat",
    value: "chat",
  },
  forum: {
    name: "Forum",
    value: "forum",
  },
};

export const VALID_MODERATION_STRATEGY_TYPES = {
  not_visible_until_approved: {
    name: "Not visible until approved",
    value: "not_visible_until_approved",
    description: "New content waits for your approval before anyone else can see it. Until you approve it, only its author and your moderators can. " +
        "Members you have trusted skip the wait. Blocking a member hides everything they have written, and approving one of their posts does not bring it back.",
  },
  visible_immediately: {
    name: "Visible immediately",
    value: "visible_immediately",
    description: "New content is visible to your community straight away, and you review it afterwards if you want to. " +
        "Blocking a member hides everything they have written, and approving one of their posts does not bring it back.",
  },
};

// The seeded Subscription Management page; seeder + Manage Subscription both route by it.
export const SUBSCRIPTION_MANAGEMENT_PAGE_SLUG = "subscription-billing-history";
